import { useState, useEffect } from 'react';

export const useChainConfig = (apiBaseUrl) => {
  const [chainConfig, setChainConfig] = useState({
    mainnet_chain_id: 42161,
    testnet_chain_id: 421614,
    default_chain_id: 42161,
    supported_chain_ids: [42161, 421614]
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchChainConfig = async () => {
      if (!apiBaseUrl) return;
      
      setIsLoading(true);
      setError(null);
      
      try {
        const response = await fetch(`${apiBaseUrl}/chain-config`);
        if (!response.ok) {
          throw new Error(`Failed to fetch chain config: ${response.statusText}`);
        }
        
        const config = await response.json();
        setChainConfig(config);
        console.log('Chain configuration loaded:', config);
      } catch (err) {
        console.warn('Failed to load chain config, using defaults:', err);
        setError(err.message);
        // Keep default values
      } finally {
        setIsLoading(false);
      }
    };

    fetchChainConfig();
  }, [apiBaseUrl]);

  return { chainConfig, isLoading, error };
};